import 'pages/vkLoginPage/VkLoginPage.scss';

import { SELF_URL } from 'api/api';
import { Logo } from 'component/appRoot/header/logo/logo';
import React from 'react';
import { generatePKCE } from 'utils/generatePckeParams';

function VkLoginPage() {
  const handleVkLoginClick = async () => {
    const { codeChallenge, codeChallengeMethod, state, codeVerifier } =
      await generatePKCE();
    localStorage.setItem(
      'vk_auth_params',
      JSON.stringify({ codeVerifier, state })
    );
    const searchParams = new URLSearchParams({
      client_id: '53918504',
      redirect_uri: `${SELF_URL}/auth`,
      scope: 'email',
      response_type: 'code',
      code_challenge: codeChallenge,
      code_challenge_method: codeChallengeMethod,
      state,
    });
    // eslint-disable-next-line no-restricted-globals
    location.replace(`https://id.vk.com/authorize?${searchParams}`);
  };

  return (
    <div className="vkLoginForm">
      <Logo className="mb-5" />

      <div className="button-vk" onClick={handleVkLoginClick}>
        <div>Войти через VK ID {'>'}</div>
      </div>
    </div>
  );
}

export { VkLoginPage };
